import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import React from 'react';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { DH } from '../../utils/DataHook';
import { pmIconsMap } from './icons/iconsMap';
import { SupportedCardNetworks } from './icons/SupportedCardNetworks';
import * as s from './styles.scss';

export interface PaymentMethodIconProps {
  url?: string;
  paymentMethod?: PaymentMethod;
  providerId?: PaymentProvider;
  lang?: string;
}

export const PaymentMethodIcon: React.FunctionComponent<PaymentMethodIconProps> =
  (props) => {
    if (props.paymentMethod === PaymentMethod.CreditCard) {
      return <SupportedCardNetworks providerId={props.providerId} />;
    }

    if (!props.url) {
      const Icon = pmIconsMap[props.paymentMethod];

      if (!Icon) {
        return null;
      }

      return (
        <span data-hook={DH.MethodsList.Item.Icon}>
          <Icon lang={props.lang} />
        </span>
      );
    }

    return (
      <div data-hook={DH.MethodsList.Item.Icon} className={s.logoContainer}>
        <img src={props.url} alt={props.paymentMethod} />
      </div>
    );
  };
PaymentMethodIcon.displayName = 'PaymentMethodIcon';
